import SmoothScroll from 'smooth-scroll';

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 1000,
	speedAsDuration: true,
} );

$( function() {
	$( '.nav-toggle' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();


		$( 'body' ).toggleClass( 'active-menu' );
		menuStateToggle();
	} );

	$( '.scroll-to' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		var target = $( this ).attr( 'href' );
		scrollToTarget( target );
	} );

	$( '.grid-selector' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );

		$( '.grid-selector' ).removeClass( 'active' );
		$this.addClass( 'active' );

		$( '.grid' ).attr( 'data-grid-type', $this.attr( 'data-grid-type' ) );
	} );

	$( '.employee-container' ).on( 'click', function( clickEvent ) {
		$( this ).addClass( 'active' );
	} );

	$( '.employee-overlay' ).on( 'click', function( clickEvent ) {
		$( '.employee-container' ).removeClass( 'active' );
	} );
} );


if ( $( 'html' ).hasClass( 'touch' ) ) {
	$( '.scroll-to' ).on( 'mouseover', function( clickEvent ) {
		clickEvent.preventDefault();
		var target = $( this ).attr( 'href' );
		scrollToTarget( target );
	} );
}

function scrollToTarget( target ) {
	$( 'body' ).removeClass( 'active-menu' );
	menuStateToggle();

	if ( target ) {
		$( window ).stop().scrollTo( target, 800, {
			'offset': -$( '.site-header' ).outerHeight()
		} );
	}
}

function menuStateToggle() {
	if ( $( 'body' ).hasClass( 'active-menu' ) ) {
		$( '.primary-navigation-container' ).removeClass( 'disabled' );

		$( '.primary-navigation li' ).each( function( i ) {
			var t = $( this );
			setTimeout( function() {
				t.addClass( 'animate' );
			}, (i + 1) * 100 );
		} );
	} else {
		$( '.primary-navigation li' ).each( function( i ) {
			var t = $( this );
			setTimeout( function() {
				t.removeClass( 'animate' );
			}, (i + 1) * 50 );
		} );

		setTimeout( function() {
			$( '.primary-navigation-container' ).addClass( 'disabled' );
		}, 500 );
	}
}
